import React, { useContext, useEffect } from 'react';
import { Container, Col } from 'reactstrap';
import { ContactUsForm } from '../../../../components/shared/ContactUsForm/ContactUsForm';
import styles from './NJRContactUs.module.css';
import getClientContent from '../../../../components/_BrandingProvider/brandContent';
import { BrandingContext } from '../../../../components/contexts/ContractContext';
import { dataLayerPush } from '../../../../helpers';
import { usePageTitle } from '../../../../components/_ReactHooks';

const NJRContactUs = () => {
    usePageTitle('Contact Us');

    useEffect(() => {
        dataLayerPush('Pageview', {
            pagePath: '/contact',
            pageTitle: 'NJR Retail Service Plans - Contact Us'
        });
    }, []);

    const branding = useContext(BrandingContext);
    const { clientId } = branding;
    const { variableText } = getClientContent(clientId);
    const claimPhoneNumber = variableText.claim.phone;
    const CustomerServPhoneNumber = variableText.customerService.phone;

    return (
        <Container className='mt-4'>
            <h1 className={styles.pageTitle}>Contact Us</h1>
            <p className={styles.contactDet}>
                {clientId == 'NJR'
                    ? 'For Billing or Questions about a Service Plan:'
                    : 'To Purchase or Ask Questions about a New Service Plan:'}
                <br />
                Call{' '}
                <a
                    href={`tel:${CustomerServPhoneNumber}`}
                    aria-label='Customer service phone number'
                    className='callLink'
                >
                    {' '}
                    {CustomerServPhoneNumber}
                </a>
            </p>
            <p className={styles.contactDet}>
                To File a Claim or Schedule Service:
                <br />
                Call{' '}
                <a
                    href={`tel:${claimPhoneNumber}`}
                    aria-label='Claim phone number'
                    className='callLink'
                >
                    {' '}
                    {claimPhoneNumber}
                </a>
            </p>
            <p className={styles.contactDet}>
                For general questions about your existing Service Plan, please fill out and submit the form below.{' '}
            </p>

            <Col
                md='7'
                lg='5'
                className='p-0'
            >
                <ContactUsForm
                    bothNames
                    descMaxLength='500'
                />
            </Col>
        </Container>
    );
};

export default NJRContactUs;
